package com.patronat.top.client.domain.profile

import com.patronat.top.client.data.profile.ClientProfileRepository
import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.ContactSupportRequest
import com.patronat.top.dto.ContactSupportResponse
import com.patronat.top.dto.DeleteCurrentUserRequest
import com.patronat.top.dto.ProfileSuccessResponse
import com.patronat.top.dto.UpdateCurrentUserRequest

class GetClientProfileUseCase(
    private val repository: ClientProfileRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<Unit, DomainResult<ProfileSuccessResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: Unit): DomainResult<ProfileSuccessResponse> {
        return repository.getCurrentUser()
    }
}

class UpdateClientProfileUseCase(
    private val repository: ClientProfileRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<UpdateCurrentUserRequest, DomainResult<ProfileSuccessResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: UpdateCurrentUserRequest): DomainResult<ProfileSuccessResponse> {
        return repository.updateCurrentUser(command)
    }
}

class SubmitClientContactMessageUseCase(
    private val repository: ClientProfileRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<ContactSupportRequest, DomainResult<ContactSupportResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: ContactSupportRequest): DomainResult<ContactSupportResponse> {
        return repository.submitContactMessage(command)
    }
}

class DeleteClientAccountUseCase(
    private val repository: ClientProfileRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<DeleteCurrentUserRequest, DomainResult<Unit>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: DeleteCurrentUserRequest): DomainResult<Unit> {
        return repository.deleteCurrentUser(command)
    }
}
